import React from "react";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { formatNumberWithSpaces } from "../../utils";
import { useCreditSelector } from "../../stores/product/product.store";
import {CreditProductInterface} from "../../interfaces/credit/credit-product.interface";

interface ProductProps {
    product: CreditProductInterface;
}

export const Product: React.FC<ProductProps> = ({ product }) => {
    const text = useCreditSelector((state: CreditState) => state.text);
    const total = (total: number) => {
        return `${formatNumberWithSpaces(total, '&nbsp;')}&nbsp;${ text.currency }`;
    }

    return (
        <>
            <div className="flex items-center justify-between">
                <div className="flex items-center mr-5">
                    <img className="bg-image-gray inline-block rounded-xl p-1 mr-2 w-[56px] h-[56px]" src={product.img}
                         alt={product.name}/>
                    <p className="text-sm">{product.name}</p>
                </div>
                <div>
                    {product.price !== product.oldPrice &&
                        <p className="text-right font-semibold text-base text-red-500 text-nowrap"
                           dangerouslySetInnerHTML={{__html: total(product.price)}}></p>}
                    <p className={`text-right font-semibold text-base text-nowrap ${product.oldPrice !== product.price && 'line-through'}`}
                       dangerouslySetInnerHTML={{__html: total(product.oldPrice)}}></p>
                    { product.extraText && <p className="text-left font-semibold text-base text-red-500 text-nowrap">{ product.extraText }</p> }
                </div>
            </div>
            <p className="text-sm mt-2.5">{text.vandute} {product.merchant}</p>
        </>
    )
}